// removed by extract-text-webpack-plugin
module.exports = {"separator":"_1Ibp4sgue06NCdxi1GHUz-","narrow":"_3ANU8_vosMP6-C1NhMUpY3","wide":"_19AtP9zNbuYKlvrewMvBdG","huge":"m6ryAM483H8jdD-lMVOpN"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/containers/Separator.css
// module id = 208
// module chunks = 0